/** 
 *  Product Quiz
 * 
 *  Product Quiz utilising Gadget
 *  Use Query params to different settings.
 *  quizId
 */

const api = new Gadget({ authenticationMode: { anonymous: true }, environment: "Production" });

console.log("We've got the api! ", api);

const introductionTemplate = ({title, description, desktopImage, mobileImage, nextActionText, nextStepId, type, stepId}) => {
  return `
    <div class="quiz_screen_start item ${type} item-${stepId}" data-page-type="${type}">
    <div class="page-width--narrow">
      <div class="inner__data">
        <h1>${ title }</h1>
        <div>${ description.html }</div>
        <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
        <span class="lg--in eu-store">Been here before? <a href="/account/login">Login</a>
        </span>
      </div>
    </div>
    ${ desktopImage && desktopImage.url ? `<img class="quiz__image" src="${ desktopImage.url }" alt="" />` : '' }
    ${ mobileImage && mobileImage.url ? `<img class="quiz__image--mobile" src="${ mobileImage.url }" alt="" />` : '' }
    <div></div>
  </div>
  `;
}

const inputTemplate = ({title, nextActionText, nextStepId, inputFieldLabel, inputFieldType, type, stepId}, pages) => {
 return `
 <div class="quiz__screen__one item ${type} item-${stepId}" data-page-type="${ type }">
 <h1>${ title }</h1>
 <div>

   <input type="${ inputFieldType }" required placeholder="${ inputFieldLabel }" name="${ inputFieldLabel.toLowerCase().trim().replace(' ', '-') }" />
 <div class="error"></div>
   </div>
   <button data-next-slide="${ nextStepId }">${ nextActionText }</button>

   ${ inputFieldType == 'email' && stepId == '16' ? `
    <a data-next-slide="${ nextStepId}" data-skip class="quiz__screen-input-skip">Don’t want to save your recommendations? Skip to your results</a>
   ` : '' }
   </div>
 `
}

const textTemplate = ({ title, description, nextActionText, nextStepId, type, desktopImage, mobileImage, stepId }) => {
  let data = `
  <div class="quiz_screen_start transparent__bg item ${type} item-${stepId}" data-page-type="${type}">
    <div class="back__btn">
      <a>
        <p>PREVIOUS</p>
        <img class="desktop-back-arrow"src="https://cdn.shopify.com/s/files/1/0578/7687/3387/files/arrow_bck_480x480.png?v=1668594962" alt="" />
        <img class="mobile-back-arrow"src="https://cdn.shopify.com/s/files/1/0578/7687/3387/files/mobile-Back-Arrow.png?v=1670276136" alt="" />
      </a>
    </div>
    <div class="page-width--narrow">
      <div class="inner__data">
        <h1>${ title }</h1>
        <div class="inner--block--color">
          <div class="quiz__text__description">
            ${ description?.html ?? '' }
          </div>
          <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
        </div> 
      </div>
    </div>
    ${ desktopImage && desktopImage.url ? `<img class="quiz__image" src="${ desktopImage.url }" alt="" />` : '' }
    ${ mobileImage && mobileImage.url ? `<img class="quiz__image--mobile" src="${ mobileImage.url }" alt="" />` : '' }
  </div>`

  return data;
}

const questionTemplate = ({title, description, answers, nextActionText, nextStepId, type, id, stepId}) => {
  let formattedAnswers = answers.edges.map(({ node: answer }) => {
    let hasHoverImage = answer.hoverImage?.url != undefined
    return `
    <div class="question__answer">
    
          ${
            answer.image && answer.image.url ? 
            `<input type="radio" id="answer-${ answer.id }" name="question-${ id }" value="${ answer.id }" data-question="${ id }" data-tag="${ answer.tagToAdd }"/>
            <label for="answer-${ answer.id }" role="button" class="answer__images ${ hasHoverImage ? '' : 'answer__images--no-hover' }">
                <img
                   class="answer__image"
                  width="130"
                  src="${ answer.image?.url }"
                  alt=""
                >
                ${ hasHoverImage ? `
                <img
                class="answer__image-hover"
               width="130"
               src="${ answer.hoverImage?.url }"
               alt=""
             >` : ''
                }
               
              </label>
            ` : `
            
            <input type="radio" id="answer-${ answer.id }" name="question-${ id }" value="${ answer.id }" data-question="${ id }" data-tag="${ answer.tagToAdd }"/>
            <label for="answer-${ answer.id }" role="button" class="answer__images ${ hasHoverImage ? '' : 'answer__images--no-hover' }">
                <div style="width: 160px; border-radius: 9999px; background-color: green">not set</div>
              </label>
            `
          }  
        
        <div class="answer__label">
          <p>${ answer.text }</p>
          ${ answer.tooltip != null ? `
          <div class="answer__tooltip-icon">
           ${tooltipIcon}
            <span class="answer__tooltip-text">${ answer.tooltip }</span>
          </div>`: ''
        
        }
          
        </div>
      </div>
`
}).join(' ');
  return `
  <div class="quiz__screen__one quiz__page-question item ${type} item-${stepId}" data-page-type="${type}">
  <div class="back__btn">
    <a>
      <p>PREVIOUS</p>
      <img class="desktop-back-arrow"src="https://cdn.shopify.com/s/files/1/0578/7687/3387/files/arrow_bck_480x480.png?v=1668594962" alt="" />
      <img class="mobile-back-arrow"src="https://cdn.shopify.com/s/files/1/0578/7687/3387/files/mobile-Back-Arrow.png?v=1670276136" alt="" />
    </a>
  </div>
    <h2 class="quiz__question-heading">${ title }</h2>
    <div class="question__answers">
      ${ formattedAnswers }
    </div>
    <div class="error"></div>
    <button data-next-slide="${ nextStepId }">${ nextActionText }</button>
      </div>
  `
}

const resultTemplate = ({ questionAnswers }, recommendedProducts) => {
  let formattedProducts = recommendedProducts.map(( product ) => {
    return {
      id: product.id,
      variants: product.variants.edges.map(({ node: variant }) => ({ id: variant.id, image: variant.productImage, price: variant.price })),
      images: product.images.edges.map(({ node: image }) => ({ url: image.source, position: image.position })),
      tags: product.tags,
      title: product.title
    }
  });

  let shampooConditioner = formattedProducts.filter(product => product.tags.includes('QUIZ-SHAMPOO') || product.tags.includes('QUIZ-CONDITIONER'));
  let treatment = formattedProducts.filter(product => product.tags.includes("QUIZ-TREATMENT"));
  let miracle = formattedProducts.filter(product => product.tags.includes("QUIZ-MIRACLE"));
  let styling = formattedProducts.filter(product => product.tags.includes("QUIZ-STYLING"));
  let hairType = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("type"));
  let hairTexture = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("texture"));
  let hairConcern = questionAnswers.edges.find(({ node }) => node.page.title.toLowerCase().includes("concern"));
  let hairGoal = questionAnswers.edges.find(({node}) => node.page.title.toLowerCase().includes("goal"));
  console.log("formatted products", formattedProducts, shampooConditioner, hairType);

  
  return `<div>
 
  <div class="quiz__screen__sixteen">
  <div class="page-width-container">
    <div class="inner__content">
      <span>Recomended just for for you</span>
      <h1>My <span class="profile">  Results</span>
      </h1>
      <p>Now that we know all about your ${ hairTexture.node.text } and <br />natural hair, let’s focus on your perfect routine </p>
    </div>
    <div class="flex--box">
    ${ hairType != undefined ?
      `<div class="content--block">
      <h2>Hair <span>type</span>
      </h2>
      <p>${ hairType.node.text }</p>
    </div>`: ''
    }
    ${ hairTexture != undefined ?
      `
      <div class="content--block second_bck">
    <h2>Hair <span>texture</span>
    </h2>
    <p>${ hairTexture.node.text }</p>
  </div>
      `: ''
    }

    ${ hairConcern != undefined ?
      ` <div class="content--block second_bck">
      <h2>Hair <span>concern</span>
      </h2>
      <p>${ hairConcern.node.text }</p>
    </div>`
    
    : ''
    }

  ${ hairGoal != undefined ? 
    `
    <div class="content--block third_bck">
    <h2>Hair <span>Goal</span>
    </h2>
    <p>${ hairGoal.node.text }</p>
  </div>

    `
  :''
  }
  </div>
</div>
  <div class="quiz__screen__sixteen_two">
  <div class="page-width-container">
    <div class="flex__bx">
      <div class="main__wrap">
        <h1>SHAMPOO & CONDITIONER 
        </h1>
        <div class="shampoo__block">
        
        ${ shampooConditioner.map((product) => {
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 

            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>
            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn">
             Add to bag
            </button>
            </form>
          </div>
          `
        }).join('') }
        </div>
      </div>
      <div class="single__block tx_blck">
        <h1>TREATMENT 
        </h1>
        ${ treatment.map((product) => { 
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn">
             Add to bag
            </button>
            </form>
          </div>
          `
        }).join('') }
      </div>
      <div class="single__block tx_blck">
      <h1>MIRACLE
        </h1>
      ${ miracle.map((product) => { 
        const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
          <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

          <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
          <input type="hidden" name="id" value="${product.variants[0].id}">
          <button type="submit" name="add" class="product-cart-btn">
           Add to bag
          </button>
          </form>
        </div>
        `
      }).join('') }
      </div>
      <div class="main__wrap">
        <h1>STYLING 
        </h1>
        <div class="shampoo__block">
        ${ styling.map((product) => { 
          const primaryImage = product.images ? (product.images.find(image => image.position == 1) || product.images[0]) : null;        const imageUrl = primaryImage ? primaryImage.url : ''; // Ensure image URL is valid
          const productTitle = product.title || ''; // Ensure product title is valid
          const productPrice = product.variants[0] ? product.variants[0].price : ''; // Ensure product price is valid
          const variantId = product.variants[0] ? product.variants[0].id : ''; // Ensure variant ID is valid
          return `
          <div class="tx_blck">
            <img src="${imageUrl}" alt="${productTitle}" style="mix-blend-mode: darken;"/>
            <p><span>${productTitle}</span></p> 
            <div class="price">
            <span class="price-item price-item--regular">€${ product.variants[0].price }</span>
            </div>

            <form method="post" action="/cart/add" id="result-${ product.variants[0].id }" data-id="result-${ product.variants[0].id }">
            <input type="hidden" name="id" value="${product.variants[0].id}"><button type="submit" name="add" class="product-cart-btn">
             Add to bag
            </button>
            </form>
          </div> 
          `
        }).join('') }
        </div>
      </div> 
      <div></div>
    </div>
    <a class="btn results-button" type="button" href="/cart/${ formattedProducts.map(product => product.variants[0].id + ':1')}?ref=from-quiz-result">
        <span class="atc-button--text">Add routine to bag</span><!--<span class="prod-cart-price-btn">$113.80</span>-->
      </a>
    <a href="/pages/hair-quiz" class="restart_txt">Restart the quiz</a>
  </div>
</div>
</div>
  `

}

const tooltipIcon = `
<span class="tooltip_icon">?</span>`

function getQueryParams(){
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(params);
}

function stringToElement(string){
  const parser = new DOMParser();
  return parser.parseFromString(string, "text/html").body.firstElementChild;
}

const quizPagesToElements = (pages) => {
  pages.push({
    type: 'resultLoading'
  })
  return pages.map(page => {
    switch(page.type) {
      case "introduction":
        return stringToElement(introductionTemplate(page));
      case "input":
        return stringToElement(inputTemplate(page, pages));
      case "text":
        return stringToElement(textTemplate(page));
      case "question":
        return stringToElement(questionTemplate(page));
      case "result":
        return stringToElement(resultTemplate(page));
      default:
        return stringToElement(`<div class="item quiz__results__loading" style=""> <h2>Loading your results... Good things take time</h2><br><div class="loading-mage"> <img src="https://cdn.shopify.com/s/files/1/0578/7687/3387/files/Spin-1.5s-184px.gif?v=1670819779" alt="loading-icon" /></div></div>`)
    }
  })
}


async function begin() {
  const { quizId, result } = getQueryParams();
  let quizToGet = '13'
  if(result){
    console.log("lets show the result!");
    let resultData = getResult(result);
    console.log(resultData);
    return;
  }
  if(quizId){
    quizToGet = quizId;
  }
  const quiz = await api.quiz.maybeFindFirst({
    filter: {
      id: {
        equals: quizToGet
      },
      // shop: {
      //   equals: "57876873387"
      // }
    },
    select: {
      id: true,
      title: true,
      pages: {
        edges: {
          node: {
            conditionalTag: true,
            stepId: true,
            nextActionText: true,
            nextStepId: true,
            type: true,
            title: true,
            id: true,
            stepId: true,
            description: {
              html: true
            },
            desktopImage: {
              url: true
            },
            mobileImage: {
              url: true
            },
            inputFieldType: true,
            inputFieldLabel: true,
            answers: {
              edges: {
                node: {
                  nextStepId: true,
                  text: true,
                  image: {
                    url: true
                  },
                  hoverImage: {
                    url: true
                  },
                  recommendedProductIds: true,
                  id: true,
                  tooltip: true,
                  tagToAdd: true

                }
              }
            }
          }
        }
      }
    }
  });
  window.simon = quiz;
  console.log("We've got the quiz! ", {quiz});

  let quizData = {
    id: quiz.id,
    name: "",
    email: "",
    answers: [],
    tags: [],
    klaviyoProperties: {}
  }

  window.quizData = quizData;


  const pages = quiz.pages.edges.map(edge => edge.node);
  console.log({pages})

  let carousel = document.createElement('wc-carousel-lite');
  window.carousel = carousel;
  // carousel.setAttribute('transition-duration', '1000'); 
  // carousel.setAttribute('center-between', ''); 
  // carousel.setAttribute('init-item', '3'); 


  carousel.append(...quizPagesToElements(pages))
  let quizEl = document.querySelector('#quiz')

  let progressBar = document.createElement('div');
  progressBar.classList.add('quiz__progress');
  progressBar.innerHTML = `<div class="quiz__progress__text"></div><div class="quiz__progress__bar" style="width: 0%"></div>`
  quizEl.append(progressBar);
  quizEl.append(carousel);

  document.querySelectorAll('[data-next-slide]').forEach(button => {
    button.addEventListener('click', event => {
      let nextSlide = event.target.getAttribute('data-next-slide');
      let parent = event.target.closest('.item');
      let type = event.target.closest('[data-page-type]').getAttribute('data-page-type');
      console.log("clicked", event.target, event.target.closest('[data-page-type]'), type);

      if(type == "introduction" || type == "text") {
        handleQuizNext(nextSlide, { quizData, pages });
      } else if(type == "input"){
        let input = parent.querySelector('input');
        let value = input.value;
        let isSkipLink = event.target.getAttribute('data-skip') != null;
        console.log("input value", event.target);
        if(isSkipLink){
          handleQuizNext(nextSlide, { quizData, pages });
          return;
        }
        if(input.reportValidity()){
          quizData[input.name] = value;
          parent.querySelector('input + .error').innerHTML = "";
          handleQuizNext(nextSlide, { quizData, pages });
        } else {
          console.log("Error they need to fill this in");
          parent.querySelector('input + .error').innerHTML = "Your input is invalid. Please try again.";
        }
      } else if(type =="question"){
          let answersContainer = parent.querySelector('.question__answers');
          let isOneAnswerSelected = answersContainer.querySelector('input:checked') != null;
          if(isOneAnswerSelected){
            let selectedAnswer = answersContainer.querySelector('input:checked');
            quizData.answers.push({[selectedAnswer.dataset.question]: selectedAnswer.value});
            if(selectedAnswer.dataset.tag){
              quizData.tags.push(selectedAnswer.dataset.tag);
            }
            // Collect answer for Klaviyo: use page title as property name (from the quiz page in Gadget)
            var stepIdClass = Array.prototype.find.call(parent.classList, function(c) { return c.indexOf('item-') === 0; });
            if (stepIdClass && pages) {
              var stepId = stepIdClass.replace('item-', '');
              var page = pages.find(function(p) { return p.stepId != null && String(p.stepId) === String(stepId); });
              if (page && page.title) {
                var propName = (typeof page.title === 'string' && page.title.trim()) ? page.title.trim() : null;
                var answerLabel = selectedAnswer.closest('.question__answer');
                var pEl = answerLabel && answerLabel.querySelector('.answer__label p');
                var answerText = (pEl && pEl.textContent) ? pEl.textContent.trim() : '';
                if (propName && answerText) quizData.klaviyoProperties[propName] = answerText;
              }
            }
            handleQuizNext(nextSlide, { quizData, pages });
            parent.querySelector('.error').innerHTML = "";
          } else {
            console.log("Woah no answer selected here!")
            parent.querySelector('.error').innerHTML = "Please Select an answer!";
          }

          
      } else {
        console.log("It's something else")
      }


    })
  })

  document.querySelectorAll('.back__btn').forEach(button => {
    button.addEventListener('click', (ev) => {
      let previous = carousel.getPrevious();
      updateProgressBar(previous, carousel.getEntries().length);
      carousel.goPrevious();
    })
  })

  window.carousel = carousel;
}
 

const handleQuizNext =(nextSlideIndex, { quizData, pages } ) => {
  const isAtEnd = carousel.getIndex() + 1 == pages.length - 1;
  let nextIndex = nextSlideIndex;
  let carouselPages = carousel.getEntries();
  console.log("were on page", { nextIndex, isAtEnd})
  if((nextIndex == 'null' || nextIndex == pages.length) && isAtEnd) { 
    console.log("end?")
    nextIndex = pages.length - 1;
    createResult(quizData);
  } else {
    nextIndex = nextSlideIndex - 1;
    const conditionalTag = pages[nextIndex].conditionalTag ||= null;
    const isNextSlideConditional = conditionalTag != null;
    const meetsCondition = quizData.tags.includes(conditionalTag);
    console.log("isNextSlideConditional", { isNextSlideConditional, meetsCondition, conditionalTag, quizData });
  
    // Check if next slide is conditional
    if(isNextSlideConditional){
      if(!meetsCondition){
        nextIndex = nextIndex + 1;
      }
    }
    // Check if next slide is text and needs to be rendered.
    if(carouselPages[nextIndex].dataset.pageType == "text"){
      let el = carouselPages[nextIndex].querySelector('.quiz__text__description');
      let res = window.micromustache.render(el.innerHTML, quizData);
      el.innerHTML = res;
    }  
  }
  carousel.goto(nextIndex);
  updateProgressBar(carousel.getIndex(), carouselPages.length)
} 



const isEmpty = (str) => {
  return !str.trim().length
}

const updateProgressBar = (currIndex, totalSlides) => {
  let progressBar = document.querySelector('.quiz__progress__bar');
  let progressText = document.querySelector('.quiz__progress__text');
  let percentage = Math.round((currIndex / (totalSlides - 2)) * 100);
  progressBar.style.width = `${percentage}%`;
  progressText.innerHTML = `${currIndex}/${ totalSlides - 2}`;
}

/**
 * Resolve email/name from quiz payload (handles dynamic input names like "your-email" from labels).
 */
function getEmailAndName(payload) {
  const email = payload.email ?? (() => {
    const k = Object.keys(payload).find(key => /email/i.test(key) && key !== 'email');
    return k ? payload[k] : '';
  })();
  const name = payload.name ?? (() => {
    const k = Object.keys(payload).find(key => /name/i.test(key) && key !== 'name');
    return k ? payload[k] : '';
  })();
  return { email: email || '', name: name || '' };
}

/**
 * Send quiz result to Klaviyo: Latest Quiz Result ID (required for segment), email, name, and custom properties from quiz pages.
 * Supports new API (klaviyo / _klOnsite) and legacy (_learnq).
 */
function sendQuizResultToKlaviyo(quizResultId, email, name, customProperties) {
  if (!email || !quizResultId) return false;
  var id = typeof quizResultId === 'string' ? parseInt(quizResultId, 10) : quizResultId;
  if (isNaN(id) || id <= 0) return false;
  var traits = {
    '$email': email,
    'Latest Quiz Result ID': id
  };
  if (name && name.trim()) traits['$first_name'] = name.trim();
  if (customProperties && typeof customProperties === 'object') {
    for (var k in customProperties) {
      if (!Object.prototype.hasOwnProperty.call(customProperties, k)) continue;
      if (k === 'Latest Quiz Result ID' || k === '$email' || k === '$first_name') continue;
      var v = customProperties[k];
      if (v != null && v !== '') traits[k] = v;
    }
  }

  // New Klaviyo snippet: klaviyo.identify(traits) — Proxy can make typeof !== 'function', so try call first
  if (window.klaviyo && window.klaviyo.identify) {
    try {
      window.klaviyo.identify(traits);
      return true;
    } catch (e) {
      console.warn('[Quiz → Klaviyo] klaviyo.identify failed', e);
    }
  }
  // Same snippet uses _klOnsite queue; push identify in the format the loader expects
  if (window._klOnsite && Array.isArray(window._klOnsite)) {
    window._klOnsite.push(['identify', traits]);
    return true;
  }
  // Legacy snippet: _learnq
  if (window._learnq && Array.isArray(window._learnq)) {
    window._learnq.push(['identify', traits]);
    return true;
  }

  console.warn('[Quiz → Klaviyo] Klaviyo script not detected (expected window.klaviyo, window._klOnsite, or window._learnq).');
  return false;
}

const createResult = async (payload) => {
  const { id, answers } = payload;
  const { email: resolvedEmail, name: resolvedName } = getEmailAndName(payload);
  console.log("Creating result!", { id, name: resolvedName, email: resolvedEmail, answers, ...payload });

  const createResult = await api.quizResult.create({
    quizResult: {
      "quiz": {
        "_link": id
      },
      name: resolvedName,
      email: resolvedEmail,
      questionResponsess: answers.map(answer => {
        return {
          create: {
            answer: {
              "_link": Object.values(answer)[0]
            }
          }
        }
      })
    }
  });

  console.log("Created result!", createResult);
  if(createResult.id != null){
    sendQuizResultToKlaviyo(createResult.id, resolvedEmail, resolvedName, payload.klaviyoProperties || {});
    var url = new URL(window.location);
    url.searchParams.set('result', createResult.id);
    url.searchParams.delete('quizId');
    // Small delay so Klaviyo identify has time to send before unload
    setTimeout(function() {
      window.location = url;
    }, 1500);
  }
}


const getResult = async(id) => {
  const result = await api.quizResult.findOne(id, {
    select: {
      id: true,
      quizId: true,
      questionAnswers: {
        edges :{
          node : {
            recommendedProductIds: true,
            text: true,
            id: true,
            page: {
              id: true,
              title: true
            }
          }
        }
      }

    }
  });
  window.result = result;

  const recommendedProducts = result.questionAnswers.edges.map(el => el.node.recommendedProductIds).flat().filter(product => product != null || product?.length > 0);
  console.log("Recommended products", recommendedProducts)
  let productsFromIds = []
  if(recommendedProducts.length > 0){
    productsFromIds = await api.shopifyProduct.findMany({
      filter: {
        OR: recommendedProducts.map(({id}) => {
          if(id == null) return;
          return {
            "id": {
              equals: id.replace("gid://shopify/Product/", "")
            }
          }
        })
      },
      select: {
        handle: true, 
        id: true, 
        tags: true,
        images: {
          edges: {
            node: {
              source: true,
              position: true
            }
          }
        },
        title: true,
        variants: {
          edges: {
            node: {
              id: true,
              productImage: {
                source: true,
                position: true
              },
              price: true
            }
          }
        }
        
      }
    });
    console.log("Products from ids", productsFromIds)
  }


  const resultsPage = stringToElement(resultTemplate(result, productsFromIds))
  console.log("Result", result, resultsPage);
  document.querySelector('#quiz').append(resultsPage)
}
console.log(getQueryParams());
document.addEventListener("DOMContentLoaded", begin);